import { useEffect, useState } from "react";

function DurationDropdown({ data, label, durationCompensationAppointment, setDurationCompensationAppointment, setFormErrors, formErrors }) {
    const [bloodVolumneText, setBloodVolumneText] = useState();
    const [selectedDuration, setSelectedDuration] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (formErrors != null) {
            if (formErrors[data.id]?.duration != "") {
                setError(formErrors[data.id]?.duration);
            } 
        }
    }, [formErrors])
    useEffect(() => {
        if (data?.sample_id == 1) {
            if (data.to_range == 100) {
                setBloodVolumneText(", up to 100 mL");
            }
            else if (data.to_range == 200) {
                setBloodVolumneText(", over 101 mL");
            }
        }
        setSelectedDuration(data?.duration || "");
    }, [data]);
    
    const handleDurationChange = (e) => {        
        const newDuration = e.target.value;
        setSelectedDuration(newDuration);
    
        if (newDuration === "") {
            setError("This field is required");
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                [data.id]: {
                    ...prevErrors[data.id],
                    duration: "This field is required", // Ensure error is scoped to 'duration'
                },
            }));
        } else {
            setError("");
            setFormErrors((prevErrors) => {
                const { [data.id]: currentErrors, ...rest } = prevErrors;
                if (currentErrors) {
                    const { duration, ...otherErrors } = currentErrors;
                    if (Object.keys(otherErrors).length === 0) {
                        return rest; // Remove entry if no other errors for this field
                    }
                    return {
                        ...rest,
                        [data.id]: otherErrors, // Keep other errors, remove 'duration'
                    };
                }
                return rest;
            });
        }
    
        // Update the durationCompensationAppointment array
        const updatedAppointments = durationCompensationAppointment.map((appointment) => {
            if (appointment.id === data.id) {
                return { ...appointment, duration: newDuration };
            }
            return appointment;
        });
    
        setDurationCompensationAppointment(updatedAppointments);
    };

    
    return (
        <>
            {/* <div className="col-12">
        </div> */}
            <div className="col-md-6">
                <label htmlFor="exampleInputEmail1" className="form-label appointment-duration-compensation">{label}{bloodVolumneText}<span className="text-danger"> *</span></label>
                <select
                    className="form-select apt-dura-comp"
                    value={selectedDuration}
                    onChange={handleDurationChange}
                    aria-label="Default select example"
                >
                    {/* disabled */}
                    <option value="" >
                        Select Duration
                    </option>
                    <option value="5 minutes">5 minutes</option>
                    <option value="10 minutes">10 minutes</option>
                    <option value="15 minutes">15 minutes</option>
                    <option value="20 minutes">20 minutes</option>
                    <option value="25 minutes">25 minutes</option>
                    <option value="30 minutes">30 minutes</option>
                    <option value="35 minutes">35 minutes</option>
                    <option value="40 minutes">40 minutes</option>
                    <option value="45+ minutes">45+ minutes</option>
                </select>
                {error && (<div>
                    <p name="wbs_element" component="div" className="text-danger" >{error}</p>
                </div>)}

            </div>

        </>
    );
}
export default DurationDropdown